import React from "react";
import Reservation from "../../Component/Reservations";

export default function SchoolReservation({ reservationMode = "예약" }) {
  return <Reservation type="학단" reservationMode={reservationMode} />;
}
